define("CCATrustedBrands.CCATrustedBrands.CCATrustedBrands.View", [
    "ccatrustedbrands_ccatrustedbrands_ccatrustedbrands.tpl",
    "Utils",
    "Backbone",
], function (
    ccatrustedbrands_ccatrustedbrands_ccatrustedbrands_tpl,
    Utils,
    Backbone
) {
    "use strict";

    return Backbone.View.extend({
        template: ccatrustedbrands_ccatrustedbrands_ccatrustedbrands_tpl,

        initialize: function initialize(options) {
            this.container = options.container;
            var env = options.container.getComponent("Environment");
            var liveConfig = env.getConfig("CCATrustedBrandsConfig") || {};

            this.config = Object.keys(liveConfig).length ? liveConfig : null;
        },

        getContext: function getContext() {
            var config = this.config;

            if (!config) {
                return { showBanner: false };
            }

            var deviceType = Utils.getDeviceType();
            var image = config.image || "";

            if (deviceType === "phone" && config.imageMobile) {
                image = config.imageMobile;
            } else if (deviceType === "tablet" && config.imageTablet) {
                image = config.imageTablet;
            }

            var linkUrl = config.linkUrl || "";

            return {
                showBanner: config.enabled !== false && !!image,
                image: image,
                altText: config.altText || "Trusted Brands",
                linkUrl: linkUrl,
                hasLink: !!linkUrl,
                isExternalLink: !!config.isExternalLink
            };
        },
    });
});
